import { Pipe, PipeTransform } from '@angular/core';
import { Strutture } from '../models/strutture';

@Pipe({
  name: 'structureDisplay'
})
export class StructureDisplayPipe implements PipeTransform {
  transform(item: Strutture | undefined | null, type: 'figlia' | 'padre'): string {
    if (!item) {
      return '';
    }

    if (type === 'figlia') {
      return !item.isParent ? item.businessName : '';
    }

    if (type === 'padre') {
      return item.isParent ? item.businessName : (item.parentBusinessName || '--');
    }

    return '';
  }
}
